import {
  composeWithScope,
  consumeProps,
  exposeHandlers,
  exposeProps,
  injectProps,
} from "recompose-scope"

/**
 * Функция, позволяющая добавить интерфейс к компонентам высшего порядка.
 * А именно, указать те пропы которые будет видны внутри, которые будут видны снаружи
 *
 * Основано на https://www.npmjs.com/package/recompose-scope
 * Отличие в том, что все параметры указываются в одном месте в начале
 * Это должно улучшить читаемость кода
 *
 * @param {object} interface - параметры из recompose-scope
 * @param {function} HOC - компонент высшего порядка, для которого задаётся интерфейс
 */
const hocInterface = (
  {
    consumeProps: consumePropsParams,
    exposeProps: exposePropsParams,
    injectProps: injectPropsParams,
    exposeHandlers: exposeHandlersParams,
  },
  HOC,
) =>
  composeWithScope(
    ...(consumePropsParams ? [consumeProps(consumePropsParams)] : []),
    ...(injectPropsParams ? [injectProps(injectPropsParams)] : []),
    HOC,
    ...(exposePropsParams ? [exposeProps(exposePropsParams)] : []),
    ...(exposeHandlersParams ? [exposeHandlers(exposeHandlersParams)] : []),
  )

export default hocInterface
